import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SourcesDocumentsComponent } from './sources-documents.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddSourcesComponent } from './add-sources/add-sources.component';
import { EditSourcesComponent } from './edit-sources/edit-sources.component';

@NgModule({
    declarations: [SourcesDocumentsComponent, AddSourcesComponent, EditSourcesComponent],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [SourcesDocumentsComponent],
})
export class SourcesDocumentsModule { }
